import React from "react";
import { FeedbackItem } from "../../Models/FeedbackItem";

const ListItem: React.FC<{
  listRef: React.RefObject<{
    refresh: () => void;
  } | null>;
  item: FeedbackItem;
  index: number;
}> = React.memo(({ item }) => {
  return (
    <React.Fragment>
      <React.Fragment>
        <div>
          <div className="my-2">
            <label className="label-2">{item.labelDescription}</label>
            <label className="label-3">{item.value}</label>
          </div>
        </div>
      </React.Fragment>
    </React.Fragment>
  );
});

export default ListItem;
